import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

export const selectCollaboratorsState = (state: RootState) => state.collaborators;

export const selectAllCollaborators = createSelector(
  [selectCollaboratorsState],
  (collaboratorsState) => collaboratorsState.allIds.map((id) => collaboratorsState.byId[id])
);

export const selectCollaboratorById = (collaboratorId: string) =>
  createSelector(
    [selectCollaboratorsState],
    (collaboratorsState) => collaboratorsState.byId[collaboratorId]
  );

export const selectFilteredCollaborators = createSelector(
  [selectAllCollaborators, selectCollaboratorsState],
  (collaborators, collaboratorsState) => {
    const { search, isActive } = collaboratorsState.filters;

    return collaborators.filter((collaborator) => {
      if (search) {
        const searchLower = search.toLowerCase();
        const matchesSearch =
          collaborator.company_name.toLowerCase().includes(searchLower) ||
          collaborator.contact_person.toLowerCase().includes(searchLower);
        if (!matchesSearch) return false;
      }
      if (isActive !== undefined && collaborator.is_active !== isActive) return false;
      return true;
    });
  }
);

export const selectCollaboratorsLoading = createSelector(
  [selectCollaboratorsState],
  (collaboratorsState) => collaboratorsState.isLoading
);

export const selectCollaboratorsError = createSelector(
  [selectCollaboratorsState],
  (collaboratorsState) => collaboratorsState.error
);
